import { Backdrop, CircularProgress, Typography, Box } from '@mui/material'

const LoadingBackdrop = ({ open, message }) => (
  <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={open}>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <CircularProgress color="inherit" />
      {message && <Typography variant="body2">{message}</Typography>}
    </Box>
  </Backdrop>
)

export default LoadingBackdrop
